import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Badge, Cell, Divider, Spacer } from '@vinted/web-ui';
import classNames from 'classnames';
import { FormattedMessage } from 'components/@support';
import PortalMergeFeedBanner from 'components/PortalMergeFeedBanner';
import PortalMergeUncontrolledModal from 'components/PortalMergeUncontrolledModal';
import SeparatedList from 'components/SeparatedList';
import StartBundleButtonWrapper from 'components/StartBundleButtonWrapper';
import FeaturedCollectionOnboardingModal from 'components/FeaturedCollection/FeaturedCollectionOnboardingModal';
import MultipleCollectionsOnboarding from 'components/FeaturedCollection/MultipleCollectionsOnboarding';
import TaxpayerBanner from 'components/TaxpayerBanner';
import useBreakpoint from 'hooks/useBreakpoint';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import useMultipleCollectionsAbTest from 'components/FeaturedCollection/useMultipleCollectionsAbTest';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { Screen } from 'constants/tracking/screens';
import { FEATURED_COLLECTION_URL } from 'constants/routes';
import { extractClosetPromoBanner } from 'data/utils/banner';
import { clickEvent } from 'libs/common/event-tracker/events';
import { isDateInTheFuture } from 'libs/utils/date';
import { navigateToPage } from 'libs/utils/window';
import * as statelessActions from 'state/banners/actions';
import * as selectors from 'state/banners/selectors';
import { actions as closetPromotionActions } from 'state/closet-promotion/slice';
import { getVasGalleryAbTest } from 'state/vas-gallery/selectors';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import ProfileCountdownBanner from './ProfileCountdownBanner';
import ReferralsBanner from './ReferralsBanner';
import VasBanner from './VasBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ProfileBanners = _ref => {
  let {
    bundleProps,
    showActions,
    viewingSelf,
    user
  } = _ref;
  const dispatch = useDispatch();
  const breakpoints = useBreakpoint();
  const banners = useSelector(selectors.getBanners);
  const vasGalleryAbTest = useSelector(getVasGalleryAbTest);
  const isVasGalleryFeatureDisabled = useSelector(getIsFeatureSwitchEnabled('disable_vas_gallery_orders'));
  const isTaxpayerBannerFsEnabled = useSelector(getIsFeatureSwitchEnabled('web_taxpayers_banners'));
  const {
    track
  } = useTracking();
  const translate = useTranslate('vas_gallery.profile_card');
  const {
    0: isCollectionOnboardingOpen,
    1: setIsCollectionOnboardingOpen
  } = useState(false);
  const isVasGalleryEnabled = vasGalleryAbTest.visible && !isVasGalleryFeatureDisabled;
  const isMultipleCollectionsEnabled = useMultipleCollectionsAbTest();
  const {
    is_favourite: isFollowed,
    id: userId,
    login: username,
    closet_countdown_end_date: closetCountdownEndDate
  } = user || {};
  useEffect(() => {
    dispatch(statelessActions.fetchBannersRequest());
    dispatch(closetPromotionActions.getPricingRequest());
  }, [dispatch]);

  function renderSeparator() {
    return breakpoints.phones ? /*#__PURE__*/_jsx(Spacer, {
      orientation: Spacer.Orientation.Horizontal,
      size: Spacer.Size.Medium
    }) : /*#__PURE__*/_jsx(Spacer, {
      orientation: Spacer.Orientation.Vertical,
      size: Spacer.Size.XLarge
    });
  }

  function renderBanner(bannerProps, onClickTarget) {
    if (!bannerProps.title) return null;
    const additionalProps = {};

    if (onClickTarget) {
      additionalProps.onClick = () => {
        track(clickEvent({
          screen: Screen.CurrentUserProfile,
          target: onClickTarget
        }));

        if (bannerProps.url) {
          navigateToPage(bannerProps.url);
        } else if (bannerProps.onClick) {
          bannerProps.onClick();
        }
      };
    }

    return /*#__PURE__*/_jsx(VasBanner, _objectSpread(_objectSpread({}, bannerProps), additionalProps));
  }

  function renderPortalMergeBanner() {
    const {
      portalMergeFeed
    } = banners;
    if (!portalMergeFeed) return null;
    return /*#__PURE__*/_jsx(PortalMergeFeedBanner, {
      banner: portalMergeFeed,
      screen: Screen.CurrentUserProfile
    });
  }

  function renderClosetPromoBanner(closetPromoBanner) {
    if (!closetPromoBanner) return null;
    const onClick = closetPromoBanner.isPromoted ? undefined : () => dispatch(closetPromotionActions.startPreCheckout());

    const bannerProps = _objectSpread(_objectSpread({}, closetPromoBanner), {}, {
      onClick,
      testId: 'cp-banner'
    });

    return renderBanner(bannerProps);
  }

  function renderPushUpBanner(pushUpBanner) {
    if (!pushUpBanner) {
      return null;
    }

    const bannerProps = _objectSpread(_objectSpread({}, pushUpBanner), {}, {
      testId: 'pushup-banner'
    });

    return renderBanner(bannerProps, ClickableElement.MultiplePushUp);
  }

  function renderVasGalleryBanner() {
    if (!isVasGalleryEnabled) {
      return null;
    }

    if (!(user !== null && user !== void 0 && user.item_count)) {
      return null;
    }

    const bannerProps = {
      icon: 'vas-gallery-card',
      subtitle: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Spacer, {
          size: Spacer.Size.Small
        }), translate('body')]
      }),
      title: /*#__PURE__*/_jsx(Cell, {
        styling: Cell.Styling.Tight,
        theme: "transparent",
        prefix: /*#__PURE__*/_jsx(Badge, {
          theme: "success",
          content: translate('new_badge')
        }),
        title: translate('title')
      }),
      url: '/items/vas_gallery/new',
      testId: 'vas-gallery-banner'
    };
    return renderBanner(bannerProps, ClickableElement.MultipleVasGallery);
  }

  function handleFeaturedCollectionBannerClick() {
    setIsCollectionOnboardingOpen(true);
    track(clickEvent({
      screen: Screen.CurrentUserProfile,
      target: ClickableElement.PromoteFeaturedCollection
    }));
  }

  function handleCollectionOnboardingNextAction() {
    track(clickEvent({
      screen: Screen.FeaturedCollection,
      target: ClickableElement.CreateCollection
    }));
    navigateToPage(FEATURED_COLLECTION_URL);
  }

  function handleCollectionOnboardingBackAction() {
    setIsCollectionOnboardingOpen(false);
  }

  function renderFeaturedCollectionBanner() {
    const {
      featuredCollectionBanner
    } = banners;
    if (!featuredCollectionBanner) return null;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [renderBanner(_objectSpread(_objectSpread({}, featuredCollectionBanner), {}, {
        onClick: handleFeaturedCollectionBannerClick,
        testId: 'featured-collection-banner'
      })), !isMultipleCollectionsEnabled && /*#__PURE__*/_jsx(FeaturedCollectionOnboardingModal, {
        show: isCollectionOnboardingOpen,
        isFeaturedCollectionCreated: false,
        onNextAction: handleCollectionOnboardingNextAction,
        onBack: handleCollectionOnboardingBackAction
      }), isMultipleCollectionsEnabled && /*#__PURE__*/_jsx(MultipleCollectionsOnboarding, {
        isOnboardingOpen: isCollectionOnboardingOpen,
        onClose: handleCollectionOnboardingBackAction
      })]
    });
  }

  function renderSelfBanners() {
    const {
      pushUpBanner,
      portalMergeFeed,
      closetPromotion
    } = banners;
    const closetPromoBanner = extractClosetPromoBanner(closetPromotion, 'my_profile');
    const classes = classNames({
      'u-flexbox': breakpoints.tabletsUp
    });
    const showInlineBanners = pushUpBanner || closetPromoBanner || portalMergeFeed || isVasGalleryEnabled;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [banners.taxpayerBanner && isTaxpayerBannerFsEnabled && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(TaxpayerBanner, {
          banner: banners.taxpayerBanner,
          isBannerInFeed: false,
          screen: Screen.CurrentUserProfile
        }), /*#__PURE__*/_jsx(Spacer, {
          size: Spacer.Size.Large
        })]
      }), banners.portalMergeWaitForMigrationModal && /*#__PURE__*/_jsx(PortalMergeUncontrolledModal, {
        banner: banners.portalMergeWaitForMigrationModal,
        screen: Screen.MergeGoToOldPortal,
        seenBannerType: "portal_merge_wait_for_migration"
      }), banners.portalMergeInitiateFromTargetModal && /*#__PURE__*/_jsx(PortalMergeUncontrolledModal, {
        banner: banners.portalMergeInitiateFromTargetModal,
        screen: Screen.MergeAnnouncementTarget,
        seenBannerType: "portal_merge_initiate_from_target"
      }), /*#__PURE__*/_jsx(ReferralsBanner, {
        bottomSpacer: breakpoints.tabletsUp && /*#__PURE__*/_jsx(Spacer, {
          size: Spacer.Size.XLarge
        })
      }), closetCountdownEndDate && isDateInTheFuture(closetCountdownEndDate) && /*#__PURE__*/_jsx(ProfileCountdownBanner, {
        userId: userId,
        username: username,
        isFollowed: isFollowed,
        showActions: showActions,
        viewingSelf: viewingSelf,
        endDate: closetCountdownEndDate,
        bottomElement: breakpoints.tabletsUp ? /*#__PURE__*/_jsx(Spacer, {
          size: Spacer.Size.XLarge
        }) : /*#__PURE__*/_jsx(Divider, {})
      }), /*#__PURE__*/_jsxs(SeparatedList, {
        separatorAtBreakpoint: {
          phones: /*#__PURE__*/_jsx(Spacer, {
            size: Spacer.Size.Medium
          }),
          tablets: /*#__PURE__*/_jsx(Spacer, {
            size: Spacer.Size.Large
          })
        },
        children: [showInlineBanners && /*#__PURE__*/_jsx("div", {
          className: classes,
          children: /*#__PURE__*/_jsxs(SeparatedList, {
            separator: renderSeparator(),
            children: [renderPushUpBanner(pushUpBanner), renderClosetPromoBanner(closetPromoBanner), breakpoints.desktops && renderVasGalleryBanner(), breakpoints.desktops && renderFeaturedCollectionBanner(), renderPortalMergeBanner()]
          })
        }), !breakpoints.desktops && renderVasGalleryBanner(), !breakpoints.desktops && renderFeaturedCollectionBanner()]
      })]
    });
  }

  function renderOtherBanners() {
    if (closetCountdownEndDate && isDateInTheFuture(closetCountdownEndDate)) {
      return /*#__PURE__*/_jsx(ProfileCountdownBanner, {
        endDate: closetCountdownEndDate,
        viewingSelf: viewingSelf,
        showActions: showActions,
        isFollowed: isFollowed,
        username: username,
        userId: userId
      });
    }

    if (!bundleProps.showBundles) return null;
    return /*#__PURE__*/_jsx(StartBundleButtonWrapper, {
      url: bundleProps.url,
      screen: Screen.UserProfile,
      children: _ref2 => {
        let {
          onClick
        } = _ref2;
        return /*#__PURE__*/_jsx(VasBanner, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "bundles.shop_title"
          }),
          subtitle: bundleProps.subtitle,
          onClick: onClick,
          testId: "profile-banner-shop-bundles-button"
        });
      }
    });
  }

  return viewingSelf ? renderSelfBanners() : renderOtherBanners();
};

export default ProfileBanners;